import { InlineMath } from 'react-katex';
import "katex/dist/katex.min.css"

// Simple component to render text with LaTeX expressions
export const MathText = ({ text, className = "" }) => {
  if (!text) return null

  return (
    <div className={className}>
      <InlineMath math={text} />
    </div>
  )
}

// Helper function to truncate text while preserving LaTeX expressions
export const truncateText = (text, maxLength = 100) => {
  if (!text) return ""
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
}
